import _extends from "@babel/runtime/helpers/extends";
import { hintCss } from "@devowl-wp/web-cookie-banner";
import { forwardRef } from "react";

/**
 * This is a very basic `hint.css` implementation for a tooltip.
 *
 * @see https://kushagra.dev/lab/hint/
 */
// eslint-disable-next-line react/display-name
const Tooltip = /*#__PURE__*/forwardRef((_ref, ref) => {
  let {
    children,
    title,
    position,
    color,
    size,
    always,
    rounded,
    noAnimate,
    bounce,
    className,
    ...rest
  } = _ref;
  return h("div", _extends({
    ref: ref
  }, rest, hintCss({
    title,
    always,
    position,
    color,
    size,
    rounded,
    noAnimate,
    bounce,
    className
  })), children);
});
export { Tooltip };